import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Modal from './Modal';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../../utils/combineStyles';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import ConfirmDialogStyles from './ConfirmDialog.styles';
import { formatFullAddress } from '../../../utils/Shipment';
import SinglePointMap from '../Maps/SinglePointMap';

const styles = theme => ({
  mapContainer: { width: '500px', height: '300px' },
  title: { marginBottom: theme.spacing.unit * 3.75 }
});
export class Maps extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    address: PropTypes.shape({
      address1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      lat: PropTypes.number.isRequired,
      long: PropTypes.number.isRequired
    }).isRequired,
    onConfirm: PropTypes.func.isRequired,
    mapName: PropTypes.string.isRequired
  };

  render() {
    const { classes, open, address, t, mapName, onConfirm } = this.props;
    const formattedAddress = formatFullAddress(address);

    return (
      <Modal
        open={open}
        classes={{
          root: classes.modalRoot,
          footer: classes.modalFooter
        }}
        keepMounted={true}
        body={
          <Fragment>
            <h2
              className={classnames(
                classes.headline6,
                classes.boldWeight,
                classes.title
              )}
            >
              {formattedAddress}
            </h2>

            <div>
              <SinglePointMap
                mapId={mapName}
                lat={address.lat}
                long={address.long}
                containerClass={classes.mapContainer}
              />
            </div>
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              color={'primary'}
              className={classes.textButton}
              onClick={onConfirm}
            >
              {t('OK')}
            </Button>
          </Fragment>
        }
      />
    );
  }
}
const translatedMaps = withNamespaces()(Maps);
export default withStyles(
  combineStyles(ConfirmDialogStyles, ButtonStyles, TypographyStyles, styles)
)(translatedMaps);
